import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from '@/App';
import { AuthProvider } from '@/contexts/AuthContext';
import { MediaProvider } from '@/contexts/MediaContext';
import '@/index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error('Elemento root não encontrado!');
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AuthProvider>
            <MediaProvider>
              <App />
            </MediaProvider>
          </AuthProvider>
        </Router>
      </HelmetProvider>
    </React.StrictMode>
  );
}